module.exports = __webpack_public_path__ + "static/media/waterpolo.48005915.png";